module.exports = __webpack_public_path__ + "static/img/matflow_homepage.57da128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matflow_homepage.png
// module id = u7hL
// module chunks = 1